<template>
    <layout>
    	<div class="row no-gutters">
			<div class="col-sm-12">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <h1 class="content-title">{{ this.pageTitle }}</h1>
                    </div>
                </div>
			</div>
    	</div>
    </layout>
</template>

<script>
	import mixin from '../mixin'
	
    export default {   
        mixins: [mixin],
        data() {
            return {
                pageID: 'home',
            }
        },	
  	}
</script>